/* Shared option lists for the fields that both the client and site forms, and
 * the tables that display them, have to agree on.
 *
 * Values mirror the CHECK constraints in
 * supabase/migrations/20260728000012_client_jurisdiction_site_environment.sql
 * and the patterns in backend/models.py. Changing a value here means changing
 * all three.
 */

export const JURISDICTIONS = [
  { value: "eu", label: "European Union" },
  { value: "uk", label: "United Kingdom" },
  { value: "ca", label: "Canada" },
  { value: "us", label: "United States" },
];

export const ENVIRONMENTS = [
  { value: "production", label: "Production" },
  { value: "staging", label: "Staging" },
  { value: "local", label: "Local" },
];

export const WCAG_TARGETS = [
  { value: "wcag22aa", label: "WCAG 2.2 AA" },
  { value: "wcag21aa", label: "WCAG 2.1 AA" },
];

const labelFrom = (options, value, fallback = "Not set") =>
  options.find((o) => o.value === value)?.label || fallback;

export const jurisdictionLabel = (value) => labelFrom(JURISDICTIONS, value);
export const environmentLabel = (value) => labelFrom(ENVIRONMENTS, value, "Production");
export const wcagTargetLabel = (value) => labelFrom(WCAG_TARGETS, value, "WCAG 2.2 AA");

/* Staging and local sites are the ones an external crawler cannot reach, so
 * they are worth calling out in a list rather than rendering as plain text. */
export const ENVIRONMENT_STYLES = {
  production: "border-gray-300 text-ink-muted",
  staging: "border-[#0F4C5C] text-[#0F4C5C] bg-[#E4EEF0]",
  local: "border-ink-subtle text-[#374151] bg-gray-100",
};
